

















import Translate from "../shared/Translate";
import { TextBoxType } from "../shared/types/TextBoxType";
import Icon from "@/components/Icon.vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component(
{
	components: {
		Icon
	}
})

export default class Textbox extends Vue
{
	@Prop() value!: string;
	@Prop() valueEnUs!: string;
	@Prop() locale!: string;
	@Prop() placeholder!: string;
	@Prop() type!: TextBoxType;

	data()
	{
		return {
			model: {
				value: this.value,
				type: this.type || TextBoxType.Text,
				valueEnUs: this.valueEnUs,
				locale: this.locale
			},

			TextBoxType: TextBoxType
		}
	}

	translate()
	{
		Translate.translate((this as any).model.valueEnUs, (this as any).model.locale, (s: string) =>
		{
			(this as any).model.value = s;

			console.log("asd", s);

			this.$emit("update:value", s);
			this.$emit("valueChanged", s);
		});
	}

	onInput()
	{
		this.$emit("update:value", (this as any).model.value);
		this.$emit("valueChanged", (this as any).model.value);
	}
}
